export class InformacaoBancaria {
  public TipoConta = '';
  public Agencia = '';
  public AgenciaDigito = '';
  public Banco = '';
  public NumeroConta = '';
  public ContaDigito = '';
  public ContaBancaria = '';
}
